module.exports = __webpack_public_path__ + "static/images/recommendation-icon.371d985080bf45f98ccd1d12071d7492.svg";